import { CountryCode } from '@app/consts/Countries'

import { NameDto } from './NameDto'
import { TickmillProductType } from './TickmillProductType'

export interface RegulatorOptionDto {
  country: {
    id: CountryCode
    name: string
    shortName?: string
  }
  regulators: RegulatorDto[]
}

export interface RegulatorDto {
  tickmillCompanyId: number
  title: string
  name: string
  options: RegulatorOptionItemDto[]
  optionsPopup: string[]
  link: string
  popup: boolean
  popupText: string[] | null
  warnings: string[]
  redirect: boolean
  preSelected: boolean
  products: RegulatorProductOption[]
}

export interface RegulatorProductOption {
  id: TickmillProductType
  name: 'FOREX & CFDs' | 'FUTURES & OPTIONS' | 'STOCKS'
  depositLimitText: string
  optionPopup: string[]
  logoUrl: string
}

export interface RegulatorOptionItemDto {
  headerString: string | null
  optionText: string
  optionType: NameDto
  showIcon: boolean
  showHeaderString: boolean
}

export enum RegulatorOptionType {
  Success = 1,
  Error = 2,
}

export const isRegulatorOptionSuccessType = (option: RegulatorOptionItemDto) => {
  return option.optionType.id === RegulatorOptionType.Success
}

export const isRegulatorOptionErrorType = (option: RegulatorOptionItemDto) => {
  return option.optionType.id === RegulatorOptionType.Error
}
